import {
  areas,
  averageInvestmentSizes,
  DropDownMenu,
  listingTypes,
  minimumInvestmentSizes,
  MultiSelect,
  required as requiredValidation,
  sectors,
  transactionTypes,
} from 'entoro-shared';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { get } from 'lodash';

const InvestmentPreferencesForm = reduxForm({
  form: 'investmentPreferences',
  enableReinitialize: true,
})((props) => {
  const { handleSubmit, submitting, update } = props;
  const availableListingTypes = get(props, 'tenant.availableListingTypes', []);
  const availableSectors = get(props, 'tenant.availableSectors', []);
  const availableTransactionTypes = get(
    props,
    'tenant.availableTransactionTypes',
    []
  );
  const areaTypes = get(props, 'tenant.areaTypes', []);
  const filteredListingTypeOptions = listingTypes.options.filter(({ value }) =>
    availableListingTypes.includes(value)
  );
  const filteredAreaOptions = areas.options.filter(({ value }) =>
    areaTypes.includes(value)
  );

  const filteredTransactionTypeOptions = availableTransactionTypes
    ? transactionTypes.options.filter(({ value }) =>
        availableTransactionTypes.includes(value)
      )
    : transactionTypes.options;

  const filteredSectorOptions = sectors.options.filter(({ value }) =>
    availableSectors.includes(value)
  );

  return (
    <div className='w-clearfix w-form'>
      <form onSubmit={handleSubmit(update)}>
        <div className='_26-black'>Investment Preferences</div>
        <div className='content-spacer'>
          <div className='w-row'>
            <div className='column-6 w-col w-col-6'>
              <Field
                component={DropDownMenu}
                validate={[requiredValidation]}
                name='minimumInvestmentSize'
                label='Minimum Investment'
                options={minimumInvestmentSizes.options}
                required
              />
            </div>
            <div className='column-right w-col w-col-6'>
              <Field
                component={DropDownMenu}
                validate={[requiredValidation]}
                name='averageInvestmentSize'
                label='Average Investment'
                options={averageInvestmentSizes.options}
                required
              />
            </div>
          </div>
          <div className='w-row'>
            <div className='column-6 w-col w-col-6'>
              <Field
                component={MultiSelect}
                validate={[requiredValidation]}
                name='preferredListingTypes'
                label='Listing Types'
                options={filteredListingTypeOptions}
                required
              />
            </div>
            <div className='column-right w-col w-col-6'>
              <Field
                component={MultiSelect}
                validate={[requiredValidation]}
                name='preferredTransactionTypes'
                label='Transaction Types'
                options={filteredTransactionTypeOptions}
                required
              />
            </div>
          </div>
          <div className='w-row'>
            <div className='column-6 w-col w-col-6'>
              <Field
                component={MultiSelect}
                name='preferredSectors'
                label='Sectors'
                options={filteredSectorOptions}
                groups={sectors.groups}
              />
            </div>
            <div className='column-right w-col w-col-6'>
              <Field
                component={MultiSelect}
                validate={[requiredValidation]}
                name='preferredAreas'
                label='Areas of Interest'
                options={filteredAreaOptions}
                required
              />
            </div>
          </div>
        </div>
        <div className='full-line' />
        <input
          type='submit'
          value='Save & Continue'
          disabled={submitting}
          className={`button-2 w-button ${submitting ? 'btn-disabled' : ''}`}
        />
      </form>
    </div>
  );
});

const mapStateToProps = (state) => ({
  initialValues: state.investorUser,
  tenant: state.tenant,
});

export default connect(mapStateToProps)(InvestmentPreferencesForm);



// WEBPACK FOOTER //
// ./src/components/Account/InvestmentPreferences/InvestmentPreferencesForm.js